import axios from "axios";
import apis from './index';


export const getCAICAICardApi = async (id) => {
    try {
        const response = await axios.get(`${apis.CACard.getCAICAICard}/${id}`,
      {
        headers: {
          'Content-Type': 'application/json',
        //   Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error creating facility:", error);
    throw error;
  }
  };